export default function DiscussionBoardIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0001 10L19.0001 1M16.3641 3.63604C14.7698 2.04493 12.6364 1.11014 10.386 1.01662C8.13551 0.923102 5.93192 1.67766 4.21115 3.13101C2.49037 4.58436 1.37776 6.63063 1.09343 8.86501C0.809105 11.0994 1.37377 13.3591 2.67571 15.1971C3.97765 17.0351 5.92203 18.3175 8.12419 18.7906C10.3263 19.2637 12.6258 18.893 14.5678 17.7518C16.5097 16.6107 17.9526 14.7823 18.611 12.6283C19.2695 10.4743 19.0954 8.15157 18.1234 6.11973M13.1821 6.81802C12.4381 6.07409 11.457 5.61436 10.4092 5.51873C9.36148 5.42311 8.31335 5.69764 7.447 6.2946C6.58065 6.89157 5.95087 7.77323 5.66711 8.78634C5.38334 9.79946 5.46355 10.88 5.89378 11.8401C6.324 12.8002 7.07705 13.5792 8.02204 14.0418C8.96703 14.5043 10.0442 14.621 11.0664 14.3718C12.0885 14.1225 12.991 13.523 13.617 12.6773C14.243 11.8317 14.5529 10.7935 14.4928 9.7431"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
